import * as yup from 'yup';

//Schemas
export const PersonalInfoSchema = yup.object().shape({
    primaryLanguage: yup.string().required(),
    secondaryLanguage: yup.string(),
    summary: yup.string().required()
})

export const ExpertiseSchema = yup.object().shape({
    // specialization: yup.string(),
    primaryExpertise: yup.string().required(),
    secondaryExpertise: yup.string(),
    tertiaryExpertise: yup.string(),
    expertiseLevel: yup.string().required()
})

export const EducationSchema = yup.object().shape({
    title: yup.string().required(), //degree?
    school: yup.string().required(),
    major: yup.string(),
    start_date: yup.string().required(),
    end_date: yup.string().required()
})

export const ExperienceSchema = yup.object().shape({
    start_date: yup.string().required(), //degree?
    present: yup.boolean(),
    end_date: yup.string().when('present', {
        is: true,
        then: (schema) => schema.notRequired(),
        otherwise: (schema) => schema.required()
    }),
    company: yup.string().required(),
    title: yup.string().required(),
    description: yup.string().required()
})

export const PortfolioSchema = yup.object().shape({
    urls: yup.array().of(yup.string().min(1)).min(1)
})

export const CertificationsSchema = yup.object().shape({
    title: yup.string().required(),
    year: yup.string().required()
})
export const CertificationsArraySchema = yup.object().shape({
    Certifications: yup.array().of(CertificationsSchema)
})

//Types
export type EducationType = yup.InferType<typeof EducationSchema>;
export type ExperienceType = yup.InferType<typeof ExperienceSchema>;
export type CertificationsType = yup.InferType<typeof CertificationsSchema>;
export type CertificationArrayType = yup.InferType<typeof CertificationsArraySchema>;
export type PortfolioType = yup.InferType<typeof PortfolioSchema>;
export type ExpertiseType = yup.InferType<typeof ExpertiseSchema>;
